module.exports = __webpack_public_path__ + "static/media/29EUNOG18.1e62d45e.jpg";